import { useState, useEffect } from 'react';
import { Box, Card, Chip, TextField, Autocomplete, ListItem, ListItemText, Tooltip, IconButton } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, ActionButton } from "../Common/DocCommonComponent";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import ShowComponents from '../Common/ShowComponent';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import DeleteIcon from '@mui/icons-material/Delete';

const DocPatientCategories = ({ Title, ...props }) => {
    const [state, setState] = useState({
        CategoryAddText: null,
        CategoryList: [],
        tempCategoryList: [],
        isDeleteClicked: false,
        SelectedCetegory: {},
        isDltClicked: false,
        slcDeleteCetegory: {}
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = () => {
        getPatientCategoryData();
        getPatientCategoryList();
    }

    useEffect(() => {
        props.registerRefreshFunction("patient_categories", getPatientCategoryData);
    }, []);

    const getPatientCategoryData = () => {
        try {
            const { appointmentId, ipAdmissionId, clinicId, doctorId, isFromIp, patientId } = props
            const q = isFromIp ? `ip_admission_id=${ipAdmissionId}&patient_id=${patientId}&clinic_id=${clinicId}&doctor_id=${doctorId}` : `appointment_id=${appointmentId}&patient_id=${patientId}`
            let params = Serviceurls.AYURVEDA_PATIENT_CATEGORIES + '?' + q
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ CategoryList: response.data.data || [] })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getPatientCategoryList = () => {
        try {
            let params = Serviceurls.AYURVEDA_PATIENT_CATEGORIES_SUGG
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({ tempCategoryList: response.data.data })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    //chip delete functions
    const categoryPopupClose = () => {
        updateState({
            isDltClicked: false,
            slcDeleteCetegory: {},
        })
    }

    const deleteCategory = () => {
        try {
            let params = Serviceurls.AYURVEDA_PATIENT_CATEGORIES
            RestAPIService.delete(params + "?id=" + state.slcDeleteCetegory?.id)
                .then((response) => {
                    if (response.data.status === "success") {
                        categoryPopupClose()
                        props.successMessage(response.data.message)
                        getPatientCategoryData()
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    // template delete functions
    const popupClose = () => {
        updateState({
            isDeleteClicked: false,
            SelectedCetegory: null,
        })
    }

    const deleteTempCategory = () => {
        try {
            RestAPIService.delete(Serviceurls.AYURVEDA_PATIENT_CATEGORIES_SUGG + "?id=" + state.SelectedCetegory?.id+"&doctor_id="+ props?.doctorId)
                .then((response) => {
                    if (response.data.status === "success") {
                        popupClose()
                        props.successMessage(response.data.message)
                        getPatientCategoryList()
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const ClearData = () => {
        updateState({
            CategoryAddText: null,
            isDeleteClicked: false,
            SelectedCetegory: {},
            isDltClicked: false,
            slcDeleteCetegory: {},
        })
    }

    const postPatientCategory = () => {
        const { appointmentId, patientId, ipAdmissionId, clinicId, doctorId, isFromIp } = props
        try {
            if (CommonValidation.removeSpace(state.CategoryAddText?.category || state.CategoryAddText) !== "") {
                const data = {
                    patient_id: patientId,
                    category: state.CategoryAddText?.category ? state.CategoryAddText?.category : state.CategoryAddText || "",
                }
                if (isFromIp) {
                    data.ip_admission_id = ipAdmissionId
                    data.clinic_id = clinicId
                    data.doctor_id = doctorId
                } else {
                    data.appointment_id = appointmentId
                }
                let path = Serviceurls.AYURVEDA_PATIENT_CATEGORIES
                RestAPIService.create(data, path)
                    .then((response) => {
                        if (response.data.status === "success") {
                            props.successMessage(response.data.message);
                            getPatientCategoryData();
                            getPatientCategoryList();
                            ClearData()
                        } else {
                            props.errorMessage(response.data.message)
                        }
                    }).catch(error => {
                        props.errorMessage(error?.response?.data?.message || error.message)
                    })
            } else {
                props.errorMessage("Select Category")
            }
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const { t } = props;

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                    <Box display="flex" alignItems={"center"} gap={"0.625dvw"}>
                        <ActionButton
                            text={"Clear"}
                            emed_tid='doc_notes_bold_clr'
                            variant={'outlined'}
                            onClick={() => ClearData()}
                        />
                        <ActionButton
                            text={"Save"}
                            emed_tid='doc_notes_bold_save'
                            disabled={!(state?.CategoryAddText || state?.CategoryAddText?.category) || props.isLocked}
                            onClick={() => { postPatientCategory() }}
                        />
                    </Box>
                </Box>
                <Box sx={{ width: "98%", margin: "0.5vw" }}>
                    <Autocomplete
                        freeSolo
                        fullWidth
                        size="small"
                        disabled={props.isLocked}
                        options={state.tempCategoryList}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.category || ""
                        }
                        value={
                            typeof state?.CategoryAddText === "string"
                                ? state.CategoryAddText
                                : state?.CategoryAddText?.category || ""
                        }
                        onChange={(e, newValue) => { updateState({ CategoryAddText: newValue }) }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                autoComplete="off"
                                label={`Enter or Select ${Title}`}
                                size="small"
                                className="eMed_DocNotes_TextFields"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (CommonValidation.ALPHA_NUM_SPLCHAR(value) || value === "") {
                                        updateState({ CategoryAddText: value });
                                    }
                                }}
                            />
                        )}
                        renderOption={(props, item) => (
                            <li {...props} style={{ padding: "0vh 1.5vh" }}>
                                <ListItem
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 0,
                                        margin: 0,
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            item?.category?.length > 90 ? (
                                                <Tooltip placement="top" title={item.category}>
                                                    <div>{item.category.slice(0, 90) + "..."}</div>
                                                </Tooltip>
                                            ) : (
                                                item.category
                                            )
                                        }
                                    />
                                    <IconButton
                                        disabled={props.isLocked}
                                        edge="end"
                                        color="error"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            updateState({
                                                isDeleteClicked: true,
                                                SelectedCetegory: item,
                                            });
                                        }}
                                    >
                                        <Tooltip placement="top" title="Delete" arrow>
                                            <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} />
                                        </Tooltip>
                                    </IconButton>
                                </ListItem>
                            </li>
                        )}
                    />
                </Box>

                <Box className="eMed_DocNotes_FreqChips_Wrapp">
                    {
                        (Array.isArray(state.CategoryList) && state.CategoryList?.length > 0) ?
                         state.CategoryList?.map((item, index) => (
                            <Chip
                                size='small'
                                className={`eMed_chip ${'eMed_Chip_Border'}`}
                                key={index}
                                label={item?.category}
                                variant={"outlined"}
                                disabled={props.isLocked}
                                onDelete={() => { updateState({ isDltClicked: true, slcDeleteCetegory: item }) }}
                            />
                        )) : null
                    }
                </Box>
                {/* Chip delete */}
                {state.isDltClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")}  ${t("Category")} - ${state.slcDeleteCetegory?.category || "-"} ?`}
                    deleteAlertPopupClose={categoryPopupClose.bind(this)}
                    removeData={deleteCategory.bind(this)}
                />}
                {/* Template Delete */}
                {state.isDeleteClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")}  ${t("Category")} ${state.SelectedCetegory?.category || "-"} From Suggestion List ?`}
                    deleteAlertPopupClose={popupClose.bind(this)}
                    removeData={deleteTempCategory.bind(this)}
                />}
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(DocPatientCategories)